var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9959 3.63824C12.4629 2.81171 13.1965 2.39844 13.9987 2.39844C14.8009 2.39844 15.5345 2.81171 17.0016 3.63824L19.0432 4.78848C20.5661 5.64645 21.3276 6.07543 21.7464 6.79285C22.1654 7.51027 22.1654 8.38527 22.1654 10.1353V12.1616C22.1654 13.9116 22.1654 14.7866 21.7464 15.5041C21.3276 16.2215 20.5661 16.6504 19.0432 17.5084L17.0016 18.6586C15.5345 19.4852 14.8009 19.8984 13.9987 19.8984C13.1965 19.8984 12.4629 19.4852 10.9959 18.6586L8.95418 17.5084C7.43131 16.6504 6.66987 16.2215 6.25096 15.5041C5.83203 14.7866 5.83203 13.9116 5.83203 12.1616V10.1353C5.83203 8.38527 5.83203 7.51027 6.25096 6.79285C6.66987 6.07543 7.43131 5.64645 8.95418 4.78848L10.9959 3.63824Z",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.6962 17.5625L20.4781 21.3074C20.9805 23.7135 21.2317 24.9166 20.7157 25.4868C20.1998 26.057 19.3037 25.5665 17.5115 24.5856L14.8591 23.1337C14.4356 22.9019 14.2239 22.786 14 22.786C13.7761 22.786 13.5644 22.9019 13.1409 23.1337L10.4884 24.5856C8.6963 25.5665 7.80024 26.057 7.28426 25.4868C6.76829 24.9166 7.01947 23.7135 7.52186 21.3074L8.30377 17.5625",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.7068 7.65221L15.4253 9.10126C15.5233 9.30297 15.7847 9.49646 16.0051 9.5335L17.3075 9.75168C18.1404 9.89165 18.3364 10.5009 17.7363 11.102L16.7237 12.1228C16.5522 12.2957 16.4583 12.6293 16.5114 12.868L16.8013 14.1318C17.0299 15.1321 16.5032 15.5191 15.6254 14.9963L14.4046 14.2676C14.1841 14.1359 13.8207 14.1359 13.5962 14.2676L12.3754 14.9963C11.5017 15.5191 10.9709 15.128 11.1996 14.1318L11.4894 12.868C11.5425 12.6293 11.4486 12.2957 11.2771 12.1228L10.2646 11.102C9.66848 10.5009 9.86037 9.89165 10.6933 9.75168L11.9957 9.5335C12.2121 9.49646 12.4734 9.30297 12.5714 9.10126L13.29 7.65221C13.682 6.86593 14.3189 6.86593 14.7068 7.65221Z",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/membership.dc1330727e9483272d33c6a55623085b.svg";
export { ForwardRef as ReactComponent };